import styled from 'styled-components';

import { SCREEN_WIDTH_BREAKPOINTS } from 'core/constants';

export { StyledTabs, StyledTab } from 'components/Tabs/styles';

export const HeaderAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 194px;

  @media (max-width: ${SCREEN_WIDTH_BREAKPOINTS.SMALL_SCREEN}px) {
    margin: 0 97px;
  }
`;
